import React from 'react';
import CustomChart from './Chart';
import Header from './Header';
import NavigationBar from './NavigationBar';

const Progress = () => (
  <>
    <Header title="Progress" />
    <CustomChart />
    <NavigationBar />
  </>
);

export default Progress;
